import FileInputUploadFieldNew from 'components/styledFormElements/FineInputUploadNew'
import React, { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useObjectUrl } from 'hooks/useObjectUrl'
import { getImageSrc } from 'services/util'

type Props = {
    onValueChange: (hasValue: boolean) => void
}

const AppLogoSettings = ({ onValueChange }: Props) => {
    const {
        control,
        formState: { errors },
    } = useFormContext<any>();
    const watchedLogo = useWatch({ control, name: 'app_logo_image' })
    const thumbPreview = useObjectUrl(watchedLogo)

    useEffect(() => {
        onValueChange?.(Boolean(watchedLogo))
    }, [watchedLogo])

    return (
        <FileInputUploadFieldNew
            label="logo"
            name="app_logo_image"
            control={control}
            errors={errors}
            preview={getImageSrc(thumbPreview)}
            allowedTypes={[
                'image/jpeg',
                'image/png',
                'image/jpg',
                'image/webp',
                'image/gif'
            ]}
            tooltip={{
                title: 'Image requirements',
                items: [
                    '2:3 aspect ratio',
                    'JPEG, JPG, PNG, WEBP, GIF',
                    '≤ 1 MB',
                ],
                position: "top"
            }}
        />
    )
}

export default AppLogoSettings
